import { config } from '@iheartjane/config';
import { asyncFlagProvider } from '@iheartjane/feature-flags';
import '@iheartjane/reefer/styles/index.css';
import { lazy } from 'react';
import { createRoot } from 'react-dom/client';

import {
  ConfigureStore,
  CustomerGlobal,
  bootstrap,
} from '@jane/monolith/marketplace';
import { ErrorBoundary } from '@jane/shared-ecomm/components';
import { EcommAppProvider } from '@jane/shared/providers';

const App = lazy(() => import('./app/App').then((a) => ({ default: a.App })));

// eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-module-scope
const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

(async () => {
  const FlagProvider = await asyncFlagProvider({
    application: { id: 'marketplace', version: config.appVersion },
    baseUrl: config.launchDarklyBaseUrl,
    clientSideID: config.launchDarklyClientID,
    eventsUrl: config.launchDarklyEventsUrl,
    streamUrl: config.launchDarklyStreamUrl,
  });
  await bootstrap({ isMarketplace: true });
  root.render(
    <ErrorBoundary whiteLabel={false} withReeferThemeProvider>
      <EcommAppProvider appMode="default">
        <FlagProvider>
          <ConfigureStore>
            <CustomerGlobal />
            <App />
          </ConfigureStore>
        </FlagProvider>
      </EcommAppProvider>
    </ErrorBoundary>
  );
})();
